import { getAssistantVersionNavState } from './getAssistantVersionNavState.js'
import { getPreviousExchangeAnchor } from './getExchangeAnchorMessage.js'
import { getExchangeDayDividerVisible } from './getExchangeDayDividerVisible.js'
import { getExchangeRowHandlers } from './getExchangeRowHandlers.js'
import { getQueryVersionNavState } from './getQueryVersionNavState.js'
import ChatThreadExchangePositionedRow from './ChatThreadExchangePositionedRow.jsx'

export default function ChatThreadExchangeRow(props) {
  const { exchange } = props
  if (!exchange) return null
  const { exchangeId, queryVersions } = exchange
  const query = getQueryVersionNavState(
    exchangeId,
    queryVersions,
    props.activeQueryVersionByExchangeId,
  )
  if (!query) return null
  const assistant = getAssistantVersionNavState(
    exchangeId,
    query.activeQuery,
    props.activeAnswerVersionByExchangeId,
  )
  const prevUser = getPreviousExchangeAnchor(
    props.exchanges,
    props.exchangeIndex,
    props.getExchangeDisplayUser,
  )
  const showDayDivider = getExchangeDayDividerVisible(
    query.currentUser,
    prevUser,
  )
  const nav = getExchangeRowHandlers(exchangeId, query, assistant, {
    onSetExchangeActiveQueryVersion: props.onSetExchangeActiveQueryVersion,
    onSetExchangeActiveAnswerVersion: props.onSetExchangeActiveAnswerVersion,
  })
  return (
    <ChatThreadExchangePositionedRow
      {...props}
      state={{
        query,
        assistant,
        nav,
        showDayDivider,
        isLastInConversation:
          props.exchangeIndex === props.exchanges.length - 1,
      }}
    />
  )
}
